

        <ul class="share"><li>
        <button (click)="openShareWindow(facebookShareUrl)" class="sharelink">
            <svg aria-label="Facebook icon" xmlns="http://www.w3.org/2000/svg" width="17" height="16" fill="none">
                <path
                    fill="#3B5998"
                    d="M6.964 8.832H5.38c-.256 0-.336-.096-.336-.336V6.56c0-.256.096-.336.336-.336h1.584V4.816c0-.64.112-1.248.432-1.808.336-.576.816-.96 1.424-1.184.4-.144.8-.208 1.232-.208h1.568c.224 0 .32.096.32.32V3.76c0 .224-.096.32-.32.32-.432 0-.864 0-1.296.016-.432 0-.656.208-.656.656-.016.48 0 .944 0 1.44h1.856c.256 0 .352.096.352.352V8.48c0 .256-.08.336-.352.336H9.668v5.216c0 .272-.08.368-.368.368h-2c-.24 0-.336-.096-.336-.336V8.832Z"
                ></path>
            </svg>
            Facebook
          </button>
        </li>

        <li>
            <button (click)="openShareWindow(twitterShareUrl)" class="sharelink">
                <svg aria-label="Twitter icon" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M11.738 2h1.994L9.377 7.083 14.5 14h-4.011L7.346 9.805 3.751 14H1.757l4.658-5.437L1.5 2h4.113l2.84 3.834L11.738 2Zm-.7 10.781h1.105l-7.13-9.627H3.828l7.21 9.627Z"
                        fill="#161616"
                    ></path>
                </svg>
                Twitter
              </button>
            </li>

           <li>
                <button (click)="openShareWindow(linkedInShareUrl)" class="sharelink">
                    <svg aria-label="Linkedin icon" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M3.403 4.56c.774 0 1.402-.572 1.402-1.28 0-.707-.628-1.28-1.402-1.28C2.628 2 2 2.573 2 3.28c0 .708.628 1.28 1.403 1.28ZM2 12.771h2.516V5.515H2v7.256ZM8.027 9.057c0-.832.394-1.646 1.335-1.646.942 0 1.173.814 1.173 1.626V13h2.505V8.875c0-2.866-1.694-3.36-2.736-3.36-1.042 0-1.616.353-2.277 1.206v-.977H5.515V13h2.512V9.057Z"
                            fill="#0976B4"
                        ></path>
                    </svg>
                    LinkedIn
                  </button>
                </li></ul>


        